import { SectionContent } from "../../amrPipeline/common/section/SectionContent";
import { SelectField } from "../../common/form-fields/SelectField";
import { CloManagerStatus } from "../../../types/clo-managers/CloManagerDetailed";

export function CloManagerProfileStatus() {
    return (
        <SectionContent title="">
            <div className="content-row">
                <div className="content-col">
                    <SelectField
                        label="Profile Status"
                        name="status"
                        values={[
                            { value: CloManagerStatus.Active, label: 'Active' },
                            { value: CloManagerStatus.Inactive, label: 'Inactive' }
                        ]}
                        placeholder="Select Profile Status"
                        optionKeyProp="value"
                        optionLabelProp="label"
                    />
                </div>
            </div>
        </SectionContent>
    );
}